export default __webpack_public_path__ + "static/media/Master.795ff956.svg";